<template>
  <v-app>
    <a id="skip-to-content" href="#mainContent">Saltar a contenido principal</a>
    <Toolbar id="banner" role="banner" />
    <BannerNotifications v-if="false" />
    <SubBar class="pa-0 ma-0" />
    <v-row no-gutters align="center" justify="center">
      <v-content aria-label="Cuerpo de Página" id="mainContent" tabindex="-1">
        <v-container fluid class="pa-0 ma-0">
          <router-view></router-view>
        </v-container>
      </v-content>
    </v-row>
    <Footer />
    <v-dialog v-model="showNotifier" width="500">
      <Notifier @close="showNotifier = false" />
    </v-dialog>
    <!-- <MessageBox :message="messageBox.message" 
      :type="messageBox.tipoIcono" 
      :show="messageBox.mensajeVisible" 
      @closing="messageBox.mensajeVisible=false" />     -->
  </v-app>
</template>
<script>
import Toolbar from "@/components/header/Toolbar";
import BannerNotifications from "@/components/header/BannerNotifications";
import SubBar from "@/components/header/SubBar";
import Footer from "@/components/Footer";
import Notifier from "@/components/Notifier";

export default {
  components: {
    Toolbar,
    BannerNotifications,
    SubBar,
    Footer,
    Notifier,
  },
  data: () => ({
    tabIndex: 0,
  }),
  computed: {
    showNotifier: {
      get() {
        return this.$store.state.process.notifier.show;
      },
      set(value) {
        this.$store.commit("process/setNotifierShow", { show: value });
      },
    },
  },
};
</script>
<style scoped>
#skip-to-content {
  left: 20px;
  position: absolute;
  transform: translateY(-100%);
}
#skip-to-content {
  background: #000000;
  color: #ffffff;
  text-decoration: none;
  height: 40px;
  padding: 8px;
  position: absolute;
  transform: translateY(-100%);
  transition: transform 0.3s;
  z-index: 100;
}

#skip-to-content:focus {
  transform: translateY(0%);
}
</style>
